import apiClient from "./apiClient";
import { CreateGuestRequest } from "../models/RequestModels/CreateGuestRequest";
import { UpdateGuestRequest } from "../models/RequestModels/UpdateGuestRequest";
import { ApiCollectionResponse } from "../models/ResponseModels/ApiCollectionResponse";
import { ApiSingleResponse } from "../models/ResponseModels/ApiSingleResponse";
import { GuestResponse } from "../models/ResponseModels/GuestResponse";

interface GetGuestsParams {
  search?: string;
}

export const getGuestsRequest = async (
  params?: GetGuestsParams,
): Promise<ApiCollectionResponse<GuestResponse>> => {
  const response = await apiClient.get<ApiCollectionResponse<GuestResponse>>(
    "/guests",
    { params },
  );

  return response.data;
};

export const getGuestRequest = async (
  id: number,
): Promise<ApiSingleResponse<GuestResponse>> => {
  const response = await apiClient.get<ApiSingleResponse<GuestResponse>>(
    `/guests/${id}`,
  );

  return response.data;
};

export const createGuestRequest = async (
  body: CreateGuestRequest,
): Promise<ApiSingleResponse<GuestResponse>> => {
  const response = await apiClient.post<ApiSingleResponse<GuestResponse>>(
    "/guests",
    body,
  );

  return response.data;
};

export const updateGuestRequest = async (
  id: number,
  body: UpdateGuestRequest,
): Promise<ApiSingleResponse<GuestResponse>> => {
  const response = await apiClient.put<ApiSingleResponse<GuestResponse>>(
    `/guests/${id}`,
    body,
  );

  return response.data;
};

export const deleteGuestRequest = async (id: number): Promise<void> => {
  await apiClient.delete(`/guests/${id}`);
};
